/**
 * Name: DftButton
 * Author: @Gaurav
 * Date: 15-07-2021
 */
import React from 'react';
import './Button.scss';
import CircularProgress from '@mui/material/CircularProgress';

const Button = ({ children, isLoading, disabled, ...props }) => {
  return (
    <button {...props} disabled={disabled ? disabled : isLoading}>
      {isLoading ? <CircularProgress style={{ color: 'white', width: 20, height: 20 }} /> : children}
    </button>
  );
};

export default Button;

